import React from 'react';
import ReactDOM from 'react-dom/client';
import './sentry'; // AUDIT-27: Sentry init (DSN yoksa no-op)
import './index.css';
import App from './App';
import { SentryErrorBoundary } from './sentry';

const FALLBACK_STRINGS = {
  tr: {
    title: 'Bir şeyler ters gitti',
    desc:  'Beklenmeyen bir hata oluştu. Geliştiriciler bilgilendirildi.',
    retry: 'Yeniden Dene',
    reload:'Sayfayı Yenile',
    dir:   'ltr',
  },
  en: {
    title: 'Something went wrong',
    desc:  'An unexpected error occurred. The developers have been notified.',
    retry: 'Try Again',
    reload:'Reload Page',
    dir:   'ltr',
  },
  ar: {
    title: 'حدث خطأ ما',
    desc:  'حدث خطأ غير متوقع. تم إبلاغ المطورين.',
    retry: 'حاول مرة أخرى',
    reload:'إعادة تحميل الصفحة',
    dir:   'rtl',
  },
};

function getFallbackLang() {
  try {
    const saved = localStorage.getItem('restaflex_language');
    if (saved && FALLBACK_STRINGS[saved]) return saved;
  } catch { /* localStorage may be blocked */ }
  return 'tr';
}

function FallbackUI({ error, resetError }) {
  const lang = getFallbackLang();
  const s = FALLBACK_STRINGS[lang] || FALLBACK_STRINGS.tr;
  return (
    <div dir={s.dir} style={{
      minHeight: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', gap: 16,
      fontFamily: 'system-ui', padding: 24, textAlign: 'center',
    }}>
      <div style={{ fontSize: 48 }}>💥</div>
      <h1 style={{ fontSize: 22, margin: 0 }}>{s.title}</h1>
      <p style={{ color: '#666', maxWidth: 480 }}>{s.desc}</p>
      {process.env.NODE_ENV === 'development' && (
        <pre style={{
          background: '#f5f5f5', padding: 12, borderRadius: 8,
          maxWidth: '90%', overflow: 'auto', fontSize: 12, textAlign: 'left',
        }}>{String(error)}</pre>
      )}
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'center' }}>
        <button
          onClick={resetError}
          style={{
            padding: '10px 20px', background: '#2563eb', color: 'white',
            border: 'none', borderRadius: 8, cursor: 'pointer', fontSize: 14,
          }}
        >{s.retry}</button>
        <button
          onClick={() => window.location.reload()}
          style={{
            padding: '10px 20px', background: 'transparent', color: '#2563eb',
            border: '1px solid #2563eb', borderRadius: 8, cursor: 'pointer', fontSize: 14,
          }}
        >{s.reload}</button>
      </div>
    </div>
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <SentryErrorBoundary fallback={(props) => <FallbackUI {...props} />}>
      <App />
    </SentryErrorBoundary>
  </React.StrictMode>
);

/**
 * Tur 310: PWA — Service Worker erken kayıt.
 * Notifications/Settings sayfasına girilmese bile static cache + offline.html
 * için SW aktive olsun. Production'da çalışır (CRA dev-server cache çakışmasın).
 */
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      // SW kayıt hatası — sessiz geç, uygulama çalışmaya devam etsin.
    });
  });
}
